import React from 'react'
import { useSelector } from 'react-redux'

import { getMultipleOrgsSelected } from '@/utils/helpers'

import { AnalyticsCards } from '../AnalyticsCards'
import Widget from '../../../components/widget/Widget'
import { ChecklistUsageWidget } from '../widgets/ChecklistUsageWidget'
import { TopWidget } from '../widgets/TopWidget'
import { OrganizationComparisonWidget } from '../widgets/OrganizationComparisonWidget'
import { DeckItemsByOrganizationWidget } from '../widgets/DeckItemsByOrganizationWidget'

export const OverviewSection = () => {
  const { hierarchy_manager: isHierarchyManager, own_organization_id } = useSelector(
    (state) => state.currentUser
  )
  const isBaltoAdmin = own_organization_id === 1
  const { filters } = useSelector((state) => state.analytics)
  const { flattenedUserOrgHierarchy } = useSelector((state) => state.orgHierarchy)
  // None selected is treated as multiple — shows org-level widgets, disables single-org features
  const multipleOrgsSelected = getMultipleOrgsSelected({
    isBaltoAdmin,
    isHierarchyManager,
    flattenedUserOrgHierarchy,
    organizations: filters.organizations,
  })

  return (
    <div data-testid="reports-summary">
      <AnalyticsCards />

      {multipleOrgsSelected && (
        <Widget
          widgetId="overview-checklistUsageByOrganization"
          label="Checklist Usage by Organization"
          subtitle="Average checklist completion across selected organizations"
          subtitlePercent="Average checklist completion percentage across selected organizations"
          showPercent
          showViewToggle
          showCsvDownload
        >
          <OrganizationComparisonWidget loadingKey="overviewPage" />
        </Widget>
      )}

      {multipleOrgsSelected ? (
        <Widget
          widgetId="overview-deckItemsByOrganization"
          label="Top Dynamic Prompts by Organization"
          subtitle="The count of each dynamic prompt usage for each selected organization"
          subtitlePercent="Average usage of each dynamic prompt for each selected organization"
          showPercent
          showViewToggle
          showCsvDownload
          percentViewDefault={false}
          tableOnly
        >
          <DeckItemsByOrganizationWidget />
        </Widget>
      ) : (
        <>
          <Widget
            widgetId="overview-checklistUsage"
            label="Checklist Usage"
            subtitle="Time series of the count of checklist items usage across selected agents"
            subtitlePercent="Time series of average checklist usage across selected agents"
            showGroupBy
            showPercent
            showViewToggle
            showCsvDownload
          >
            <ChecklistUsageWidget />
          </Widget>

          <Widget
            widgetId="overview-topDeckItems"
            label="Top Dynamic Prompts"
            subtitle="The count of the 5 most frequent dynamic prompts used across selected agents"
            subtitlePercent="Average usage of the 5 most common dynamic prompts across selected agents"
            showPercent
            showViewToggle
            showCsvDownload
          >
            <TopWidget accessor="deck_item" label="Dynamic Prompts" />
          </Widget>
        </>
      )}
    </div>
  )
}
